<template>
  <FieldDashboard role="zone" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import FieldDashboard from "@/components/Dashboard/FieldDashboard.vue";

// Zone manager dashboard (role_id 3): see components/Dashboard/FieldDashboard.vue
export default defineComponent({
  components: { FieldDashboard },
});
</script>
